import { useContext } from 'react'
import ModalComponent from './Modal'
import { DesignContext } from 'contexts/DesignContext'
import objectPath from 'object-path'
import { getCurrentUi } from '../action/Data'
import ModalSuccessNoti from './ModalSuccessNoti'

const ModalCondition = () => {
  const designContext = useContext(DesignContext)
  const {
    elementAction,
    setElementAction,
    isUiChanged,
    setIsUiChanged,
    setOpenModal,
    jsonForm,
  } = designContext
  const { modal = {} } = isUiChanged
  const modalKey = objectPath.get(modal, 'modalAction.formCode')
  const isModalRender = objectPath.get(isUiChanged, ['isModalRender'])
  const isOpenModal = !!isModalRender && isModalRender === modalKey
  const isOpenSuccessModal = objectPath.get(isUiChanged, [
    'successModal',
    'isOpen',
  ])

  const closeModalCondition = () => {
    let modalUiKey = objectPath.get(modal, 'ui.key')
    objectPath.set(elementAction, ['openModal', modalKey], false)
    if (modalUiKey && modalUiKey !== modalKey) {
      objectPath.set(elementAction, ['openModal', modalUiKey], false)
    }
    setElementAction(elementAction)
    objectPath.del(isUiChanged, 'modal')
    setIsUiChanged(isUiChanged)
    setOpenModal(null)
    objectPath.del(isUiChanged, 'isModalRender')
    setIsUiChanged(isUiChanged)
  }

  if (isOpenModal) {
    return (
      <ModalComponent
        {...modal}
        uiModalCode={modalKey}
        closeModalCondition={closeModalCondition}
        isModalCondition={true}
        isOpenModal={isOpenModal}
      />
    )
  }
  if (isOpenSuccessModal) {
    return <ModalSuccessNoti />
  }
  return <></>
}

export default ModalCondition
